import $ from 'jquery'
import _ from 'lodash'

const CURSOR_PLACEHOLDER = 'cursor-placeholder'

/**
 * Given rich text that has been saved to the database, returns it in a format
 * appropriate for display. In particular, opens links in a new tab and prevents
 * reverse tabnabbing
 */
function prepareRichText(text) {
	// #20963 don't do any formatting for null or undefined text
	if (_.isNil(text)) {
		return text
	}
	let container = $(`<div>${text}</div>`)
	container.find('a')
		// open all links in a new tab
		.attr('target', '_blank')
		// prevent reverse tabnabbing https://www.owasp.org/index.php/Reverse_Tabnabbing
		.attr('rel', 'noopener noreferrer')

	// #32521 strip out any placeholders that weren't cleaned up properly
	container.find('.' + CURSOR_PLACEHOLDER).remove()

	return container.html()
}

export default prepareRichText
export { CURSOR_PLACEHOLDER }
prepareRichText.__filename__ = 'components/rich-text/prepare-rich-text.js'
